module.exports = __webpack_public_path__ + "img/new-logo.79231ed9.png";